import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import { WirtschaftsFoerderungService } from '@ui/shared/util-api';
import type { EconomicDevelopmentFilterKey } from '../../types/economic-development-filter';

@Injectable({ providedIn: 'root' })
export class IndustrySelectFilterConfigService extends FilterConfigService<EconomicDevelopmentFilterKey, WirtschaftsFoerderungService> {
    public override type = 'multiselect' as const;

    constructor() {
        super(
            new MultiFilterModel('industryIds', 'Gewerbe', []),
            inject(WirtschaftsFoerderungService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllWfIndustries({
            order: [],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
